<template>
  <b-card class="cardStyle">
    <p class="m-0 title">
      <b-icon icon="info-circle-fill" scale="1.3"></b-icon>&nbsp; &nbsp;Your Site Activation
      Checklist
    </p>
    <b-row class="mt-2">
      <b-col class="mainText" cols="7" sm="7" md="7" lg="8" xl="9">
        Please refer to the Site Activation Checklist to identify and complete your activation
        requirements. Consult your start-up point of contact for any questions.
      </b-col>
      <b-col cols="5" sm="5" md="5" lg="4" xl="3" class="text-center">
        <b-img :src="image" fluid></b-img>
      </b-col>
    </b-row>
    <div class="textInside mt-3">
      It is recommended that you pay special attention to:
    </div>
    <b-row class="textInside mt-3">
      <b-col class="p-0">
        <b-icon icon="bag-fill" scale="1.2" style="color: #0060AA;"></b-icon>
        <p class="mt-2">Required Documents and Qualifications</p>
      </b-col>
      <b-col class="p-0">
        <b-icon icon="info-circle-fill" scale="1.2" style="color: #0060AA;"></b-icon>
        <p class="mt-2">Required Trainings and System Access</p>
      </b-col>
      <b-col class="p-0">
        <b-icon icon="gear-fill" scale="1.2" style="color: #0060AA;"></b-icon>
        <p class="mt-2">Required Facilities and Equipments</p>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import img from '../../../images/siteActivationChecklist.svg';
  export default {
    data() {
      return {
        image: img,
      };
    },
  };
</script>

<style scoped>
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #0060aa;
  }
  .mainText {
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.5px;
    font-feature-settings: 'case' on;
    color: #383838;
    margin-top: 2rem;
  }
  .textInside {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }
</style>
